
import { TranslationRecord } from '../../types';

export const contact: TranslationRecord = {
  // Contact Section
  contactTitle: 'Contact Us',
  contactSubtitle: 'We\'re here to help with your questions',
  contactInformation: 'Contact Information',
  
  // Contact Hero
  contactHeroTitle: 'Get in Touch',
  contactHeroSubtitle: 'We\'re here to help make your stay in Thessaloniki unforgettable. Contact us for reservations, questions, or personalized assistance.',
  
  // Form fields
  name: 'Name',
  email: 'Email',
  message: 'Message',
  send: 'Send',
  phoneNumber: 'Phone',
  address: 'Address',
  location: 'Location',
  receptionHours: 'Reception Hours',
  weekdayHours: 'Monday to Friday: 8:00 AM - 3:00 PM',
  weekendHours: 'Weekends & Holidays: 11:00 AM - 3:00 PM',
  afterHoursCheckIn: '(online check-in available after hours)',
  directBookingBenefits: 'Additional Benefits When You Book Direct',
  discountBenefit: '10% Direct Booking Discount',
  earlyCheckinBenefit: 'Check-in before 3:00 PM (subject to availability)',
  lateCheckoutBenefit: 'Check-out after 11:00 AM (subject to availability)',
  personalizedRecommendations: 'Personalized local recommendations',
  whatsAppAssistance: 'Contact us on WhatsApp',
};
